import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router/immutable';
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootEpic from '../epics/index';
import rootReducer from './rootReducer';
import { createEpicMiddleware } from 'redux-observable';

export const observableMiddleware = createEpicMiddleware();
export const configureStore = initialState => {
  const history = createBrowserHistory();
  const middleware = [
    thunkMiddleware,
    routerMiddleware(history),
    observableMiddleware,
  ];

  const newCreateStore = Reflect.apply(applyMiddleware, null, middleware)(
    createStore,
  );
  const reducer = rootReducer(history);

  const store =
    typeof __DEVELOPMENT__ !== 'undefined' && __DEVELOPMENT__
      ? newCreateStore(
          reducer,
          initialState,
          window.__REDUX_DEVTOOLS_EXTENSION__ &&
            window.__REDUX_DEVTOOLS_EXTENSION__(),
        )
      : newCreateStore(reducer, initialState);

  observableMiddleware.run(rootEpic);
  return {
    history,
    store,
  };
};
